/**
 * 企业到期检查工具方法
 * 用于检查企业是否已到期，并决定是否显示蒙层限制敏感操作
 */

import ajax from '@/utils/ajax';


/**
 * 获取企业扩展信息（包含到期时间）
 * 接口: GET /v1/basic/corp/corp/getCorpExtendInfo
 * @returns {Promise<Object>} 返回企业扩展信息
 */
export async function getCorpExpireInfo() {
    try {
        const res = await ajax.gatewayGet('/v1/basic/corp/corp/getCorpExtendInfo', {}, { noShowMsg: true });
        const { code, msg, message, data } = res || {};

        if (code === 0 && data) {
            return data;
        }

        throw new Error(msg || message || '获取企业信息失败');
    } catch (error) {
        console.error('[getCorpExpireInfo] 请求失败:', error);
        throw error;
    }
}

/**
 * 检查企业是否已到期
 * @returns {Promise<Object>} 返回 { isExpired: boolean, expireInfo: Object }
 */
export async function checkCorpExpire() {
    try {
        const expireInfo = await getCorpExpireInfo();
        const expireTime = Number(expireInfo.expire_time);

        // 检查到期时间是否有效
        if (!expireTime || isNaN(expireTime)) {
            return {
                isExpired: false,
                expireInfo,
            };
        }

        // 当前时间戳（秒）
        const currentTime = Math.floor(Date.now() / 1000);

        // 判断是否已到期
        const isExpired = currentTime > expireTime;

        return {
            isExpired,
            expireInfo,
            expireTimestamp: expireTime,
            currentTimestamp: currentTime,
        };
    } catch (error) {
        console.error('[checkCorpExpire] 检查失败:', error);
        // 检查失败时默认不显示蒙层，避免影响正常用户
        return {
            isExpired: false,
            expireInfo: null,
            error,
        };
    }
}

export default {
    getCorpExpireInfo,
    checkCorpExpire,
};
